import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function SubmitLogsCard({ item, index, activeInactiveSubmitLog, downloadFile, deleteFiles, highLightId }) {
  const reducer = useSelector((reducer_state) => reducer_state);
  const { Users, UserDetails } = reducer;
  const { logInRights } = Users;
  const [show, setShow] = useState(false);
  const role = UserDetails?.userInfo?.role;
  const [state, setState] = useState({
    submitDisabled: true,
    downloadDisabled: true,
  });
  const { t } = useTranslation('common');

  const { submitDisabled, deleteButtonShow } = state;
  useEffect(() => {
    let submit_Disabled = true;
    let delete_ButtonShow = true;
    if (role !== 'Admin') {
      logInRights?.forEach((log) => {
        submit_Disabled = log?.submitTechPack;
        if (activeInactiveSubmitLog) {
          delete_ButtonShow = log?.submitTechPack;
        } else {
          delete_ButtonShow = log?.downloadTechPack;
        }
      });
    }
    setState((prev) => ({
      ...prev,
      submitDisabled: submit_Disabled,
      deleteButtonShow: delete_ButtonShow,
    }));
  }, [logInRights]);

  const getFilesName = () => {
    if (item?.files?.length > 1) {
      const arr = [];
      item?.files?.forEach((file) => {
        arr.push(file?.filename);
      });
      return arr.join(',');
    }
    return item?.files[0]?.filename || '';
  };

  const getDownloadedByEmails = () => {
    if (item?.downloadByEmails?.length > 0) {
      const arr = [];
      item?.downloadByEmails?.forEach((file) => {
        arr.push(file?.email);
      });
      return arr.join(',');
    }
    return item?.downloadByEmails || '';
  };

  return (
    <div
      id="accordion"
      className="col-lg-4 "
      key={index}
      onClick={() => {
        setShow(!show);
      }}
    >
      <div className={`listing-card card mt-3 ${highLightId?.toString() === item?._id?.toString() ? 'active-log' : ''}`}>
        <div className="card-header d-flex align-items-center">
          <p className="py-2 px-3 m-0 font-bold">{activeInactiveSubmitLog && item?.supplier}</p>
          <ul className="card-header-icon ml-auto">
            {item?.message && (
              <li>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip className="text-tooltip" id="tooltip_description">
                      {item.message}
                    </Tooltip>
                  }
                >
                  <button className="btn p-0" type="button">
                    <i className="icon-Chat f-18" />
                  </button>
                </OverlayTrigger>
              </li>
            )}
            {(item?.files?.length > 0 || item?.zipFiles?.length > 0) && (
              <li>
                <button
                  className="btn p-0"
                  type="button"
                  title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DOWNLOAD_FILE')}
                  onClick={() => downloadFile(item)}
                >
                  <i title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DOWNLOAD_EXCEL_PDF')} className="icon-download" />
                </button>
              </li>
            )}
            {deleteButtonShow && (
              <li>
                <button
                  className="btn p-0"
                  type="button"
                  title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DELETE')}
                  onClick={() => deleteFiles(item?._id)}
                >
                  <i title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DELETE')} className="icon-delete" />
                </button>
              </li>
            )}
            {activeInactiveSubmitLog && submitDisabled && (
              <li>
                <div className="custom-switch-on-off w-110">
                  <BootstrapSwitchButton checked={item?.isActive} onlabel="Active" offlabel="Inactive" onChange={() => activeInactiveSubmitLog(item, index)} />
                </div>
              </li>
            )}
          </ul>
        </div>
        <div className="card-body">
          {activeInactiveSubmitLog ? (
            <ul className="card-ul ">
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.BY')} </strong>
                {item?.sendBy}
              </li>
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.LOG_DATE')} </strong>
                {moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')}
              </li>
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.TO')} </strong>
                {item?.sentUsers?.join(', ')}
              </li>
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.CC')} </strong>
                {item?.ccMail?.join(', ') || ''}
              </li>
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.BCC')} </strong>
                {item?.bccMail?.join(', ') || ''}
              </li>

              {show && (
                <div>
                  <li>
                    <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.FILES')} </strong>
                    <p className="mt-1">{item?.submitedModules?.join(',') || ''}</p>
                  </li>
                  <li>
                    <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DOWNLOADED_BY')} </strong>
                    {getDownloadedByEmails()}
                  </li>
                </div>
              )}
            </ul>
          ) : (
            <ul className="card-ul ">
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.DOWNLOADED_BY')} </strong>
                {`${item?.downloadedBy?.firstName} ${item?.downloadedBy?.lastName} `}
              </li>
              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.LOG_DATE')} </strong>
                {moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')}
              </li>

              <li>
                <strong>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_LOGS.FILES')} </strong>
                {getFilesName()}
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubmitLogsCard;
